import { functions } from "../firebase";

// Event writes go through Admin SDK callables, never straight to Firestore. A
// gated event keeps its meetingURL and replayURL in Event/{id}/protected/links,
// which the rules deny to every client, so only the callable can read or write
// them. See functions/src/adminEvents.ts.
export type EventSaveResult = {
  eventId: string;
  gated: boolean;
  publicMeetingURL: string | null;
  publicReplayURL: string | null;
  publicDocCarriesProtectedURLs: boolean;
  notified?: boolean;
  updated?: boolean;
};

export type EventLinks = {
  eventId: string;
  meetingURL: string;
  replayURL: string;
};

export const saveEventViaCallable = async ({
  event,
  notify,
}: {
  event: any;
  notify?: boolean;
}): Promise<EventSaveResult> => {
  const call = functions.httpsCallable("adminSaveEvent");
  const response = await call({ event, notify: Boolean(notify) });
  return response.data as EventSaveResult;
};

export const deleteEventViaCallable = async ({
  eventId,
}: {
  eventId: string;
}): Promise<{ eventDeleted: boolean; eventId: string }> => {
  const call = functions.httpsCallable("adminDeleteEvent");
  const response = await call({ eventId });
  return response.data as { eventDeleted: boolean; eventId: string };
};

export const fetchEventLinks = async ({
  eventId,
}: {
  eventId: string;
}): Promise<EventLinks> => {
  const call = functions.httpsCallable("adminGetEventLinks");
  const response = await call({ eventId });
  return response.data as EventLinks;
};
